import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { WorkflowCreatePage } from 'src/modules/tools/components/pages/workflow-create.page';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

export const Route = createFileRoute('/tools/workflows/create')({
  component: WorkflowCreateComponent,
  validateSearch: (search) =>
    globalSearchSchema
      .merge(
        z.object({
          phoneVersion: globalSearchSchema.shape.phoneVersion.default(
            'v1' as const
          ),
          fromWorkflowId: z.string().optional(),
        })
      )
      .parse(search),
});

function WorkflowCreateComponent() {
  const { fromWorkflowId } = Route.useSearch();
  return (
    <AuthenticateRoute>
      <WorkflowCreatePage fromWorkflowId={fromWorkflowId} />
    </AuthenticateRoute>
  );
}

export default Route;
